export const CELL_TYPES = ['UC-MSC', 'BM-MSC', 'AD-MSC', 'HSC', 'iPSC', 'other'];
export const LOT_STATUSES = [
    'received',
    'in_qc',
    'released',
    'quarantined',
    'in_use',
    'depleted',
    'retired',
];
export const QC_ENTRY_TYPES = [
    'flow_cytometry',
    'viability',
    'morphology',
    'sterility',
    'karyotype',
    'mycoplasma',
    'endotoxin',
    'custom',
];
export const USER_ROLES = ['provider', 'researcher', 'tech', 'admin', 'auditor'];
export const UC_MSC_POSITIVE_MARKERS = ['CD73', 'CD90', 'CD105'];
export const UC_MSC_NEGATIVE_MARKERS = [
    'CD34',
    'CD45',
    'CD11b',
    'CD14',
    'CD19',
    'CD79a',
    'HLA-DR',
];
export const UC_MSC_ALL_MARKERS = [...UC_MSC_POSITIVE_MARKERS, ...UC_MSC_NEGATIVE_MARKERS];
export const ADMINISTRATION_ROUTES = [
    'intra-articular',
    'intravenous',
    'intrathecal',
    'topical',
    'other',
];
export const ALERT_SEVERITIES = ['info', 'warning', 'critical'];
export const REPORT_TYPES = ['qc_summary', 'batch_comparison', 'compliance_audit', 'coa'];
//# sourceMappingURL=constants.js.map